import { LogOutIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { authService } from '@/services/auth_service'
import { toast } from 'sonner'
import { useAuth } from '@/hooks/useAuth'
import { logger } from '@magnetar/utils'

export default function Logout() {
  const navigate = useNavigate()
  const { token } = useAuth()

  const handleLogout = async () => {
    try {
      const result = await authService.logout(token)
      if (result.success) {
        navigate('/login')
      } else {
        toast.error(result.error?.message || '登出時發生錯誤')
      }
    } catch (error) {
      logger.error('登出時發生錯誤', error)
      toast.error('登出時發生錯誤')
    }
  }

  return (
    <div className="px-6 py-4">
      <button
        onClick={handleLogout}
        className="group flex items-center w-full px-3 py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none"
      >
        <LogOutIcon className="w-4 h-4 mr-2 stroke-gray-500 group-hover:stroke-gray-700" />
        登出
      </button>
    </div>
  )
}
